module.exports = __webpack_public_path__ + "static/media/plus-icon.583e7bfd.webp";